module.exports = __webpack_public_path__ + "static/media/rm_06-18.2b820047.png";